import { Button } from "antd";
import { useTranslation } from "react-i18next";

const FastCheckoutFooter = ({ onNext, disabled }) => {
    const { t } = useTranslation();
    return (
    <div className="page-fixed-footer-container">
    <Button
      style={{
        width: "100%",
      }}
      type="primary"
      size="large"
      disabled={disabled}
      onClick={onNext}
    >
      {t("common.next")}
    </Button>
  </div>
    );
  };
export default FastCheckoutFooter;  